namespace RioERP.Masters {
    export interface ModeForm {
        Name: Serenity.StringEditor;
    }

    export class ModeForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Mode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModeForm.init)  {
                ModeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ModeForm, [
                    'Name', w0
                ]);
            }
        }
    }
}
